/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Button } from '@wordpress/components';
import { escapeHTML } from '@wordpress/escape-html';

export default function Home() {
  const username = escapeHTML(rv_dashboard_data.username);
  const isProActive = Boolean(rv_dashboard_data.isActive);

  const buttons = isProActive ? (
      <Button href='admin.php?page=riovizual&path=license' className='rv_dash-btn rv-btn-filled'>
        {__('Enter Your Product Key')}
      </Button>
  ) : (
      <Button href='https://riovizual.com/pricing/' target='_blank' rel='noopener noreferrer' className='rv_dash-btn rv-btn-filled'>
        {__('Upgrade to Pro')}
      </Button>
  );

  const cardItems = [
    {
      img: 'https://riovizual.com/wp-content/uploads/2024/04/Support.png',
      title: __('Need Assistance?'),
      desc: __('Our support team is here to help with any questions or issues you encounter. Reach out and get the assistance you need, fast!'),
      link: 'https://wordpress.org/support/plugin/riovizual/',
      linkText: __('Get Support')
    },
    {
      img: 'https://riovizual.com/wp-content/uploads/2024/04/Community.png',
      title: __('Knowledge Base'),
      desc: __('Explore in-depth guides, best practices, and detailed tutorials tailored to help you make the most out of RioVizual.'),
      link: 'https://riovizual.com/docs/',
      linkText: __('View Docs')
    },
    {
      img: 'https://riovizual.com/wp-content/uploads/2024/04/Document.png',
      title: __('Connect with Fellow Users'),
      desc: __('Share ideas, get tips, and learn from other RioVizual users in our vibrant community. Collaboration starts here!'),
      // link: 'https://www.facebook.com/groups/riovizual',
      link: 'https://community.wprio.com/',
      linkText: __('Join Now')
    }
  ];

  return (
    <div className='rv_dash-home'>
			<div className='welcome-sec rv_dash-spacing'>
        <div className='ws-left'>
          <h4>{__('Hello ') + username}</h4>
          <h1>{__('Welcome to RioVizual')}</h1>
          <p>{__("Build professional tables effortlessly and elevate your website's content to the next level. Our intuitive drag-and-drop table builder helps you create every form of table all within the Gutenberg editor!")}</p>
          {buttons}
          <Button href='https://riovizual.com' target='_blank' rel='noopener noreferrer' className='rv_dash-btn rv-btn-unfilled'>
            {__('Explore Now')}
          </Button>
        </div>
        <div className='ws-right'>
					<img src="https://riovizual.com/wp-content/uploads/2024/05/RioVizual-WordPress-Table-Plugin.png" alt="RioVizual WordPress Table Plugin" />
        </div>
      </div>

      <div className='rv_dash-card-sec'>
        <div className='rv_dash-grid rv_dash-grid-col-3'>
          {cardItems.map((item, index) => (
            <div className='rv_dash-grid-item' key={index}>
              <img src={item.img} alt={item.title} />
              <h5>{item.title}</h5>
              <p>{item.desc}</p>
              <Button href={item.link} target='_blank' rel='noopener noreferrer' className='rv_dash-btn btn-has-svg'>
                {item.linkText} ↗
              </Button>
            </div>
          ))}
        </div>
      </div>

      <div className='leave-a-review rv_dash-spacing'>
        <img src='https://riovizual.com/wp-content/uploads/2025/02/review.png' alt='review icon' width='80' />
        <h3>{__('We’d Love Your Feedback!')}</h3>
        <p>{__('Enjoying RioVizual? Share your experience and help others find the perfect table-building solution!')}</p>
        <Button href='https://wordpress.org/support/plugin/riovizual/reviews/#new-post' target='_blank' rel='noopener noreferrer' className='rv_dash-btn rv-btn-filled'>
          {__('Leave A Review')}
        </Button>
      </div>
    </div>
  );
}
